import { proxy } from "valtio";
import type { ResolvedAdContent } from "@services/media/commands/cmdResolveAds";

export const resolvedAdStore = proxy<{
    byId: Record<number, ResolvedAdContent | null>;
}>({
    byId: {},
});
